export const FoundationPlanName = "Foundation";
export const ProPlanName = "Pro";
export const MonthlySubscriptionName = "Monthly";
export const YearlySubscriptionName = "Annual";
export const ElectronicSubscriptionName = "+ Live Feedback";

const LiveFeedBackPrice = 5.00;

export const FoundationPlanMonthlyPrice = 12.99;
export const FoundationPlanYearlyPrice = FoundationPlanMonthlyPrice * 10;

export const FoundationPlusPlanMonthlyPrice = FoundationPlanMonthlyPrice + LiveFeedBackPrice;
export const FoundationPlusPlanYearlyPrice = FoundationPlusPlanMonthlyPrice * 10;

export const ProPlanMonthlyPrice = 19.99;
export const ProPlanYearlyPrice = ProPlanMonthlyPrice * 10;

export const ProPlusPlanMonthlyPrice = ProPlanMonthlyPrice + LiveFeedBackPrice;
export const ProPlusPlanYearlyPrice = ProPlusPlanMonthlyPrice * 10;

export const FoundationMonthlyDescription = `
FreeLimbs <b>Foundation Monthly</b> subscription, without Live feedback.

Best for <b>beginner</b> and <b>intermediate</b> drummers.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>270+</b> superb drumless music tracks to enjoy your practice.
`;

export const FoundationYearlyDescription = `
FreeLimbs <b>Foundation Annual</b> subscription, without Live feedback.

Best for <b>beginner</b> and <b>intermediate</b> drummers.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>270+</b> superb drumless music tracks to enjoy your practice.
`;

export const FoundationPlusMonthlyDescription = `
FreeLimbs <b>Foundation Monthly</b> subscription, <b>with Live feedback</b>.

Best for <b>beginner</b> and <b>intermediate</b> drummers with electronic drums**, who want to improve faster.

<b>Real-time feedback</b> and after-practice <b>analysis</b> on your <b>timing</b>, <b>dynamics</b>, <b>precision</b>, and <b>unisons</b>.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>270+</b> superb drumless music tracks to enjoy your practice.

** Live feedback works on devices with a browser supporting the WebMIDI standard. Please read <a href="https://www.freelimbs.com/faq#what-do-i-need-to-use-the-live-feedback-feature" target="_blank" rel="noopener noreferrer">What do I need to use the Live feedback feature?</a> in the FAQ <b>before</b> you purchase a subscription.
`;

export const FoundationPlusYearlyDescription = `
FreeLimbs <b>Foundation Annual</b> subscription, <b>with Live feedback</b>.

Best for <b>beginner</b> and <b>intermediate</b> drummers with electronic drums**, who want to improve faster.

<b>Real-time feedback</b> and after-practice <b>analysis</b> on your <b>timing</b>, <b>dynamics</b>, <b>precision</b>, and <b>unisons</b>.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>270+</b> superb drumless music tracks to enjoy your practice.

** Live feedback works on devices with a browser supporting the WebMIDI standard. Please read <a href="https://www.freelimbs.com/faq#what-do-i-need-to-use-the-live-feedback-feature" target="_blank" rel="noopener noreferrer">What do I need to use the Live feedback feature?</a> in the FAQ <b>before</b> you purchase a subscription.
`;

export const ProMonthlyDescription = `
FreeLimbs <b>Pro Monthly</b> subscription, without Live feedback

Best for <b>advanced</b> and <b>professional</b> drummers.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>Swing jazz</b> workouts for Jazz, Fusion, Bebop, and Big Band.

<b>World rhythms</b> workouts for Samba, Songo, Mambo, Salsa (Cascara, Campana), Cha-Cha, Bossa Nova, Bembe, Conga, Mozambique, Caribbean, Fusion, and more.

<b>Linear</b> pattern workouts, plus <b>grooves & fills studio</b> where you can create millions of grooves & fills with billions of variations.

<b>300+</b> superb drumless music tracks to enjoy your practice.
`;

export const ProYearlyDescription = `
FreeLimbs <b>Pro Annual</b> subscription, without Live feedback

Best for <b>advanced</b> and <b>professional</b> drummers.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>Swing jazz</b> workouts for Jazz, Fusion, Bebop, and Big Band.

<b>World rhythms</b> workouts for Samba, Songo, Mambo, Salsa (Cascara, Campana), Cha-Cha, Bossa Nova, Bembe, Conga, Mozambique, Caribbean, Fusion, and more.

<b>Linear</b> pattern workouts, plus <b>grooves & fills studio</b> where you can create millions of grooves & fills with billions of variations.

<b>300+</b> superb drumless music tracks to enjoy your practice.
`;

export const ProPlusMonthlyDescription = `
FreeLimbs <b>Pro Monthly</b> subscription, <b>with Live feedback</b>.

Best for <b>advanced</b> and <b>professional</b> drummers with electronic drums**, who want to improve faster.

<b>Real-time feedback</b> and after-practice <b>analysis</b> on your <b>timing</b>, <b>dynamics</b>, <b>precision</b>, and <b>unisons</b>.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>Swing jazz</b> workouts for Jazz, Fusion, Bebop, and Big Band.

<b>World rhythms</b> workouts for Samba, Songo, Mambo, Salsa (Cascara, Campana), Cha-Cha, Bossa Nova, Bembe, Conga, Mozambique, Caribbean, Fusion, and more.

<b>Linear</b> pattern workouts, plus <b>grooves & fills studio</b> where you can create millions of grooves & fills with billions of variations.

<b>300+</b> superb drumless music tracks to enjoy your practice.

** Live feedback works on devices with a browser supporting the WebMIDI standard. Please read <a href="https://www.freelimbs.com/faq#what-do-i-need-to-use-the-live-feedback-feature" target="_blank" rel="noopener noreferrer">What do I need to use the Live feedback feature?</a> in the FAQ <b>before</b> you purchase a subscription.
`;

export const ProPlusYearlyDescription = `
FreeLimbs <b>Pro Annual</b> subscription, <b>with Live feedback</b>.

Best for <b>advanced</b> and <b>professional</b> drummers with electronic drums**, who want to improve faster.

<b>Real-time feedback</b> and after-practice <b>analysis</b> on your <b>timing</b>, <b>dynamics</b>, <b>precision</b>, and <b>unisons</b>.

<b>Straight backbeat</b> workouts for Rock, Funk, Pop, R&B, Gospel, Fusion, Country, Metal, Smooth Jazz, and more.

<b>Swung backbeat</b> workouts for Blues, Ballads, Hip-Hop, R&B, Gospel, and more.

<b>Swing jazz</b> workouts for Jazz, Fusion, Bebop, and Big Band.

<b>World rhythms</b> workouts for Samba, Songo, Mambo, Salsa (Cascara, Campana), Cha-Cha, Bossa Nova, Bembe, Conga, Mozambique, Caribbean, Fusion, and more.

<b>Linear</b> pattern workouts, plus <b>grooves & fills studio</b> where you can create millions of grooves & fills with billions of variations.

<b>300+</b> superb drumless music tracks to enjoy your practice.

** Live feedback works on devices with a browser supporting the WebMIDI standard. Please read <a href="https://www.freelimbs.com/faq#what-do-i-need-to-use-the-live-feedback-feature" target="_blank" rel="noopener noreferrer">What do I need to use the Live feedback feature?</a> in the FAQ <b>before</b> you purchase a subscription.
`;
